import React, { useEffect, useRef } from "react";
import { Btn } from "../ui";

export default function SignaturePad({ onSave, height = 140 }: { onSave: (blob: Blob) => void; height?: number }) {
  const ref = React.useRef<HTMLCanvasElement>(null);
  const drawing = useRef(false);
  const ctxRef = useRef<CanvasRenderingContext2D | null>(null);
  const cropCanvas = (canvas: HTMLCanvasElement): HTMLCanvasElement => {
    const ctx = canvas.getContext("2d");
    if (!ctx) return canvas;
    const { width, height: h } = canvas;
    const img = ctx.getImageData(0, 0, width, h);
    const data = img.data;
    let minX = width, minY = h, maxX = -1, maxY = -1;
    for (let y = 0; y < h; y++) {
      for (let x = 0; x < width; x++) {
        const alpha = data[(y * width + x) * 4 + 3];
        if (alpha > 0) {
          if (x < minX) minX = x;
          if (y < minY) minY = y;
          if (x > maxX) maxX = x;
          if (y > maxY) maxY = y;
        }
      }
    }
    if (maxX < minX || maxY < minY) return canvas;
    const dpr = canvas.clientWidth ? canvas.width / canvas.clientWidth : 1;
    const pad = Math.round(4 * dpr);
    minX = Math.max(0, minX - pad);
    minY = Math.max(0, minY - pad);
    maxX = Math.min(width - 1, maxX + pad);
    maxY = Math.min(h - 1, maxY + pad);
    const cropW = maxX - minX + 1;
    const cropH = maxY - minY + 1;
    const out = document.createElement("canvas");
    out.width = cropW;
    out.height = cropH;
    const octx = out.getContext("2d");
    if (octx) {
      octx.drawImage(canvas, minX, minY, cropW, cropH, 0, 0, cropW, cropH);
    }
    return out;
  };
  useEffect(() => {
    const c = ref.current; if (!c) return; const dpr = Math.max(1, Math.floor(window.devicePixelRatio || 1));
    c.width = c.clientWidth * dpr; c.height = height * dpr; const ctx = c.getContext("2d"); if (!ctx) return; ctx.scale(dpr, dpr); ctx.lineWidth = 2; ctx.lineCap = "round"; ctx.strokeStyle = "#0f172a"; ctxRef.current = ctx;
  }, [height]);
  const getPos = (e: React.PointerEvent) => { const r = ref.current!.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
  const down = (e: React.PointerEvent) => { drawing.current = true; const p = getPos(e); ctxRef.current?.beginPath(); ctxRef.current?.moveTo(p.x, p.y); };
  const move = (e: React.PointerEvent) => { if (!drawing.current) return; const p = getPos(e); ctxRef.current?.lineTo(p.x, p.y); ctxRef.current?.stroke(); };
  const up = () => { drawing.current = false; };
  const clear = () => { const c = ref.current; const ctx = ctxRef.current; if (c && ctx) { ctx.clearRect(0, 0, c.width, c.height); } };
  const save = () => {
    const c = ref.current; if (!c) return;
    const cropped = cropCanvas(c);
    cropped.toBlob(b => { if (b) onSave(b); }, "image/png");
  };
  return (
    <div className="grid gap-2">
      <div className="rounded-xl border border-slate-300 bg-white overflow-hidden">
        <canvas ref={ref} style={{ width: "100%", height: `${height}px` }} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up} />
      </div>
      <div className="flex gap-2 justify-end">
        <Btn variant="secondary" onClick={clear}>Löschen</Btn>
        <Btn onClick={save}>Übernehmen</Btn>
      </div>
    </div>
  );
}
